"use client";

import type React from "react";
import { cn } from "@/shared/utils/utils";

interface HamburgerIconProps {
  isActive?: boolean;
  className?: string;
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  isActive = false,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col justify-center items-center",
        "gap-[7px]",
        "w-[22px] h-[22px]",
        "relative",
        className
      )}
    >
      <span
        className={cn(
          "block w-[22px] h-[3px]",
          "bg-white rounded-sm",
          "transition-all duration-300 ease-[cubic-bezier(0.645,0.045,0.355,1)]",
          "origin-center",
          isActive && "translate-y-[5px] rotate-45"
        )}
      />
      <span
        className={cn(
          "block w-[22px] h-[3px]",
          "bg-white rounded-sm",
          "transition-all duration-300 ease-[cubic-bezier(0.645,0.045,0.355,1)]",
          "origin-center",
          isActive && "-translate-y-[5px] -rotate-45"
        )}
      />
    </div>
  );
};
